import normalizeUrl from 'normalize-url';

const getNormalizeURL = (url?: string | null): string => {
  if (!url) return '';

  try {
    return normalizeUrl(url);
  } catch (_) {
    return encodeURI(`https://${url}`);
  }
};

export default getNormalizeURL;
